import { Box, Typography, useTheme, useMediaQuery, Link } from "@mui/material";
import { NewReleases } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

import TopScreen from "../../assets/landing/home-dashboard.png";

import { keyframes } from "@mui/system";

const slideInFromRight = keyframes`
    0% {
        transform: translateX(100%);
        opacity: 0;
    }
    100% {
        transform: translateX(0);
        opacity: 1;
    }
`;

const NewTop = () => {
    const theme = useTheme();
    const navigate = useNavigate();
    const isNonMobileScreens = useMediaQuery("(min-width: 1000px)");

    return (
        <Box
            width="100%"
            maxWidth="90%"
            padding="2rem 6%"
            display={isNonMobileScreens ? "flex" : "block"}
            gap="2rem"
            justifyContent="center"
            alignItems="center"
            margin="0 auto"
        >
            <Box flexBasis={isNonMobileScreens ? "40%" : undefined}>
                <Box
                    display="flex"
                    flexDirection="column"
                    gap="1rem"
                    justifyContent="center"
                    height="100%"
                    width="100%"
                >
                    <Typography
                        fontSize="1rem"
                        color="white"
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.5rem",
                            background: "grey",
                            padding: "0.5rem",
                            borderRadius: "0.5rem",
                            width: "fit-content",
                            cursor: "pointer",

                            "&:hover": {
                                background: "black",
                                // add animation to change the bg color smoothly
                                transition: "background 0.5s",
                                cursor: "pointer",

                            }
                        }}
                        onClick={() => navigate("/updates")}
                    >
                        <NewReleases />
                        <span>Latest Updates</span>
                    </Typography>
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "1rem",
                        }}
                    >
                        <Typography
                            fontSize="3rem"
                            color="white"
                            fontWeight="bold"
                            sx={{
                                // add shadow to the text
                                textShadow: `0 2px 2px ${theme.palette.grey[500]}`,
                            }}
                        >
                            Introducing Uben
                        </Typography>
                    </Box>
                    <Typography
                        fontSize="1.3rem"
                        color="black"
                        sx={{
                            width: "100%",
                        }}
                    >
                        Master anything with Uben <br /> The ultimate spaced repetition platform.
                    </Typography>
                    <Typography
                        fontSize="1rem"
                        color="white"
                        sx={{
                            fontWeight: 'bold',
                            marginTop: '0.5rem',
                        }}
                    >
                        450+ Users & 550+ User Decks !
                    </Typography>
                    <Link href="https://www.producthunt.com/products/uben?embed=true&utm_source=badge-featured&utm_medium=badge&utm_campaign=badge-uben" target="_blank" rel="noopener noreferrer" sx={{
                        textDecoration: 'none',
                        transition: 'all 0.2s ease',
                        '&:hover': {
                            transform: 'translateY(-2px)'
                        },
                        width: isNonMobileScreens ? '200px' : '170px',
                        height: 'auto',
                    }}>
                        <img alt="Uben - Master anything - The ultimate spaced repetition platform | Product Hunt" width={isNonMobileScreens ? '200px' : '170px'} height='auto' loading="lazy" src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=1093333&theme=light&t=1773209040331" />
                    </Link>
                </Box>
            </Box>
            <Box
                flexBasis={isNonMobileScreens ? "62%" : undefined}
                display="flex"
                justifyContent="center"
                alignItems="center"
            >
                <Box
                    display="flex"
                    flexDirection="column"
                    gap="1rem"
                    justifyContent="center"
                    height="100%"
                    // add animation to the image , make it slide in from the right
                    sx={{
                        animation: `${slideInFromRight} 1s ease-out`, // Apply the animation
                    }}
                >
                    <img src={TopScreen} alt="Uben learning platform interface showcasing spaced repetition features" width="100%" fetchpriority="high" decoding="async" />
                </Box>
            </Box>
        </Box>
    );
};

export default NewTop;